"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var FullscreenCartIcon = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FullscreenCartIcon, _React$Component);

  function FullscreenCartIcon() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FullscreenCartIcon.prototype;

  _proto.render = function render() {
    var _this = this;

    var count = this.props.cartItemsCount > 0 ? /*#__PURE__*/_react["default"].createElement("span", null, this.props.cartItemsCount) : false;
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: 'fullscreen-icon fullscreen-cart-icon has-custom-focus',
      onClick: function onClick() {
        return _this.props.showCart && _this.props.showCart();
      },
      title: 'Cart',
      "aria-label": "Cart",
      tabIndex: 0
    }, /*#__PURE__*/_react["default"].createElement("button", {
      tabIndex: -1
    }, /*#__PURE__*/_react["default"].createElement("svg", {
      viewBox: "0 0 18 16",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
      id: "aa",
      d: "M0 4h18l-3.033 12H3z"
    }), /*#__PURE__*/_react["default"].createElement("mask", {
      id: "cc",
      x: "0",
      y: "0",
      width: "18",
      height: "12",
      fill: "#fff"
    }, /*#__PURE__*/_react["default"].createElement("use", {
      xlinkHref: "#aa"
    })), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14 5A5 5 0 0 0 4 5",
      id: "bb"
    }), /*#__PURE__*/_react["default"].createElement("mask", {
      id: "dd",
      x: "0",
      y: "0",
      width: "10",
      height: "10",
      fill: "#fff"
    }, /*#__PURE__*/_react["default"].createElement("use", {
      xlinkHref: "#bb"
    }))), /*#__PURE__*/_react["default"].createElement("g", {
      strokeWidth: "2",
      stroke: "currentColor",
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/_react["default"].createElement("use", {
      mask: "url(#cc)",
      xlinkHref: "#aa"
    }), /*#__PURE__*/_react["default"].createElement("use", {
      mask: "url(#dd)",
      xlinkHref: "#bb"
    })))), count);
  };

  return FullscreenCartIcon;
}(_react["default"].Component);

var _default = FullscreenCartIcon;
exports["default"] = _default;